export default __webpack_public_path__ + "static/media/icon_flag_spain.489b1e78.svg";